module.exports = {
  blogPostCfg: {
    maxPages: 5,
    pageBufferSize: 1,
  },
}
